import type { Params } from "react-router-dom";

const ALLOWED_PATHNAMES = [
  "jumbo-picker",
  "jumbo-forms",
  "jumbo-pay",
  "for-businesses",
  "features",
];

// Check if the contact us button should be shown on the page
const checkContactUsButtonShouldBeShown = (params: Readonly<Params<string>>) => {
  const pathname = window.location.pathname;

  return (
    ALLOWED_PATHNAMES.some((allowedPathname) =>
      pathname.includes(allowedPathname)
    ) &&
    !Object.keys(params).some(
      (key) => key === "profileCategory" || key === "profilePage"
    )
  );
};

export default checkContactUsButtonShouldBeShown;
